export default __webpack_public_path__ + "static/media/part_1_con.6a55dbee.gif";